<template>
  <div class="header-container">
    <div class="router-view">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        separator=">">
        <el-breadcrumb-item
          v-for="(item, index) in $route.meta"
          :key="index">
          <span
            class="cursor"
            @click="changeRouter(item.url)">
            {{ item.name }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="admin-right">
      <img
        class="admin-head"
        width="32px"
        src="../assets/images/dog.jpg">
      <el-dropdown
        @command="handleCommand"
        trigger="click">
        <span class="el-dropdown-link">
          {{ name }}
          <i class="el-icon-arrow-down el-icon--right"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="password">
            <i class="el-icon-edit dk-icon-back"/>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item command="signOut">
            <img
              src="../assets/images/logout.png"
              class="dk-icon-back">
            退出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码弹窗 -->

    <el-dialog
      width="480px"
      :title="passwordTitle"
      :visible.sync="passwordDialog">
      <el-form
        :model="addBody"
        label-position="left"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm">
        <el-form-item
          label="原密码:"
          prop="old_password">
          <el-input
            class="dk-input"
            placeholder="请输入原密码"
            v-model="addBody.old_password"/>
        </el-form-item>
        <el-form-item
          label="新密码:"
          prop="new_password">
          <el-input
            class="dk-input"
            placeholder="请输入新密码"
            v-model="addBody.new_password"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="passwordDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onSureClick('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/jslib/dk-utils'
import { changePassword } from '../api/user'

export default {
  data() {
    return {
      passwordTitle: '修改密码',
      passwordDialog: false,
      addBody: {
        old_password: '',
        new_password: '',
        uuid: '1234567890123456789',
      },
      rules: {
        old_password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
      },
    };
  },

  created() {},
  computed: {
    name() {
      return utils.getCookie('name')
    },
  },
  methods: {
    onSureClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.network().changePassword()
        } else {
          console.log('error submit!!');
        }
      });
    },
    changeRouter(url) {
      console.log(url);
      this.$router.push({ path: url });
    },
    handleCommand(command) {
      if (command === 'signOut') {
        this.signOut()
        return
      }
      this.passwordDialog = true
    },
    signOut() {
      utils.setCookie('token', null)
      utils.setCookie('name', null)
      this.$router.push({ path: '/login' })
    },
    network() {
      return {
        changePassword: async () => {
          const { status } = await changePassword(this.addBody)
          console.log(status, '--------------');

          if (status !== 200) return
          this.passwordDialog = false
          this.$notify({
            title: '修改成功',
            message: '修改密码成功',
            type: 'success',
          });
          this.signOut()
        },
      }
    },
  },
};
</script>

<style lang="scss">
.header-container {
  padding:0 57px 0 30px;
  height: 73px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  margin: 0;
  .search-row {
    width: 100%;
  }
  .router-view {
  }
  .filter-view {
    display: flex;
    padding-right: 25px;
    align-items: center;
    .type {
      margin: 0 10px;
      color: #223040;
      background: rgba(0, 0, 0, 0);
      margin: 0 15px;
    }
  }
  .admin-right{
    height: 100%;
    display: flex;
    align-items: center;
    .admin-head{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }
  }
}
.dk-icon-back {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 12px 12px 0 0;
}

.top-search-input {
  width: 220px;
  margin: 0 10px;
  .search-icon {
    width: 36px !important;
    height: 36px !important;
    padding: 10px 11px !important;
  }
  .search-row {
    margin-bottom: 30px;
  }
}
.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/top-bar.vue